import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES: Record<string, string> = {
  // Auth pages
  '/': 'Login',
  '/login': 'Login',
  '/forgot-password': 'Forgot Password',
  '/reset-password': 'Reset Password',

  // Admin pages
  '/admin': 'Admin',
  '/admin/home': 'Home',
  '/admin/users': 'Users',
  '/admin/logs': 'Logs',
  '/admin/ui': 'UI Components',

  // Fundraising pages
  '/fundraising': 'Fundraising',
  '/fundraising/raises': 'Raises',
  '/fundraising/analytics': 'Analytics',
  '/fundraising/vdr': 'VDR',
  '/fundraising/domain-groups': 'Domain Groups',
  '/fundraising/term-sheet-settings': 'Term Sheet Settings',

  // Settings
  '/settings': 'Settings',
  '/settings/profile-settings': 'Profile Settings',

  // Decks
  '/decks/content-rewards': 'Content Rewards',
};

function getPageTitle(pathname: string): string {
  // Exact match
  if (PAGE_TITLES[pathname]) {
    return PAGE_TITLES[pathname];
  }

  // Dynamic route matching
  if (pathname.startsWith('/fundraising/raises/') && pathname.includes('/settings')) {
    return 'Raise Settings';
  }
  if (pathname.startsWith('/fundraising/raises/')) {
    return 'Raise Detail';
  }
  if (pathname.startsWith('/fundraising/funds/')) {
    return 'Fund Detail';
  }
  if (pathname.startsWith('/fundraising/vdr/') && pathname.includes('/settings')) {
    return 'VDR Settings';
  }
  if (pathname.startsWith('/partner/')) {
    return 'Partner Hub';
  }

  // Fallback to section name
  if (pathname.startsWith('/admin')) return 'Admin';
  if (pathname.startsWith('/fundraising')) return 'Fundraising';
  if (pathname.startsWith('/settings')) return 'Settings';
  if (pathname.startsWith('/decks')) return 'Deck';

  return 'o37';
}

export function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    document.title = pageTitle === 'o37' ? 'o37' : `${pageTitle} | o37`;
  }, [location.pathname]);
}

export default usePageTitle;
